<template>
  <div class="dashboard container-fluid">
    <SwitchUser />

    <StatCards v-if="checkPermissionByIds([permissions.DASHBOARD_VIEW])" />

    <Announcement />

    <div class="data__tables -mx-4">
      <vs-row>
        <!-- recently added table -->
        <vs-col class="vx-col w-full md:w-2/5 px-4">
          <RecentlyAddedItems v-if="checkPermissionByIds([permissions.DASHBOARD_VIEW])" />
        </vs-col>

        <!-- stock alert -->
        <vs-col class="vx-col w-full md:w-3/5 px-4">
          <StockAlert v-if="checkPermissionByIds([permissions.DASHBOARD_VIEW])" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SwitchUser from '@/views/dashboard/components/SwitchUser.vue'
import StatCards from '@/views/dashboard/components/StatCards.vue'
import Announcement from '@/views/dashboard/components/Announcement.vue'
import RecentlyAddedItems from '@/views/dashboard/components/RecentAddedItems.vue'
import StockAlert from '@/views/dashboard/components/StockAlert.vue'

export default {
  name: 'Dashboard',

  components: {
    SwitchUser,
    StatCards,
    Announcement,
    RecentlyAddedItems,
    StockAlert
  },

  computed: {
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds'])
  }
}
</script>

<style lang="scss">
.dashboard {
  .announcement {
    .notification__content {
      background: green;

      border-left: 5px solid darkgreen;

      p {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
